import { PRIORITES } from "./content";
import { useInView } from "./useInView";

export const Priorites = () => {
  const [ref, cls] = useInView(0.15);
  return (
    <section id="priorites" ref={ref} className={`bg-mm-alt text-mm-ink py-24 md:py-32 ${cls}`} data-testid="priorites-section">
      <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-[160px_1fr] gap-12">
        <p className="mm-lab text-mm-golddark">Les quatre priorités</p>
        <div className="min-w-0">
          <ul className="st divide-y divide-mm-ink/20 border-y border-mm-ink/20">
            {PRIORITES.map((p) => (
              <li key={p.key} className="py-6 grid sm:grid-cols-2 gap-4 items-end group" data-testid={`priorite-${p.key}`}>
                <span className={`disp mm-big ${p.color} break-words group-hover:translate-x-2 transition-transform duration-500`}>{p.name}</span>
                <span className="mm-body">{p.text}</span>
              </li>
            ))}
          </ul>
          <p className="mm-body mt-10 max-w-xl">
            Vous pourrez discuter l'ordre, en ajouter, les améliorer. <strong>Mais écrivez-les. Financez-les. Mesurez-les. Rendez compte.</strong>
          </p>
        </div>
      </div>
    </section>
  );
};
